import { render, staticRenderFns } from "./FortalSegEvents.vue?vue&type=template&id=e7ac9294&scoped=true"
import script from "./FortalSegEvents.vue?vue&type=script&lang=js"
export * from "./FortalSegEvents.vue?vue&type=script&lang=js"
import style0 from "./FortalSegEvents.vue?vue&type=style&index=0&id=e7ac9294&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7ac9294",
  null
  
)

export default component.exports